"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_EN_05({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {`.cls-1 {
        stroke-width: 0px;
        fill: ${color};
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m5.4,30c-1.26,0-2.29-1.03-2.29-2.29V2.29c0-1.26,1.03-2.29,2.29-2.29h19.19c.61,0,1.18.24,1.62.67.43.43.67,1.01.67,1.62v25.42c0,1.26-1.03,2.29-2.29,2.29H5.4ZM5.4.96c-.73,0-1.33.59-1.33,1.33v25.42c0,.73.59,1.33,1.33,1.33h19.19c.73,0,1.33-.59,1.33-1.33V2.29c0-.73-.59-1.33-1.33-1.33H5.4Z"
      />
      <path
        className="cls-1"
        d="m8.12,16.66c-.76,0-1.39-.62-1.39-1.39V5c0-.76.62-1.39,1.39-1.39h13.77c.76,0,1.39.62,1.39,1.39v10.27c0,.76-.62,1.39-1.39,1.39h-13.77Zm-.42-.96h.42s4.93,0,4.93,0l-.2-.56c-.25-.71-.15-1.47.29-2.08.44-.62,1.12-.97,1.87-.97.46,0,.9.13,1.27.39l.25.17.72-.54c.08-.06.18-.1.29-.1.15,0,.3.07.39.19.16.21.11.52-.1.67l-.72.54.09.28c.14.47.13.98-.03,1.44l-.2.56h5.35V4.58H7.69v11.12Zm7.31-2.65c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33Z"
      />
      <path
        className="cls-1"
        d="m10.83,9.8c-.14,0-.27-.06-.36-.16-.09-.1-.13-.22-.12-.35,0-.13.06-.25.16-.33,1.23-1.11,2.83-1.73,4.5-1.73s3.26.61,4.5,1.73c.2.18.21.48.04.68-.09.1-.22.16-.36.16-.12,0-.23-.04-.32-.12-1.06-.95-2.42-1.48-3.85-1.48s-2.79.53-3.85,1.48c-.09.08-.2.12-.32.12h0Z"
      />
      <path
        className="cls-1"
        d="m15,26.06c-1.76,0-3.19-1.43-3.19-3.19s1.43-3.19,3.19-3.19,3.19,1.43,3.19,3.19-1.43,3.19-3.19,3.19Zm-1.12-5.12c-.69.4-1.11,1.14-1.11,1.93,0,1.23,1,2.23,2.23,2.23s2.23-1,2.23-2.23c0-.79-.43-1.53-1.11-1.93l-.63-.37v1.17c0,.27-.22.48-.48.48s-.48-.22-.48-.48v-1.17l-.63.37Z"
      />
    </svg>
  );
}
